import Model from './Model'

export default class Promo extends Model {
  resource() {
    return 'promos'
  }
}
